"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import { Container } from "react-bootstrap";
import "./index.css";
import axios from "axios";
import PageTitle from "@/components/common-components/page-title/PageTitle";

import { generateCacheKey, withManualCache } from "@/utlility/cache-service";

export default function MarketArea() {
  const [marketArea, setMarketArea] = useState([]);

  useEffect(() => {
    const fetchMarketArea = async () => {
      try {
        const url = `${process.env.NEXT_PUBLIC_API_URL}/api/market-areas`;
        const payload = {
          organization_key: process.env.NEXT_PUBLIC_ORGANIZATION_KEY,
        };
        const cacheKey = generateCacheKey(url, 'POST', payload);

        const result = await withManualCache(cacheKey, async () => {
          const response = await axios.post(url, payload);
          return response.data;
        });

        setMarketArea(result.data);
      } catch (error) {
        // console.error("Error fetching market area:", error);
      }
    };
    fetchMarketArea();
  }, []);

  return (
    <>
      <PageTitle
        image="/images/pages/categories/banner/bg-banner.webp"
        name="Target Region"
      />

      <section>
        <Container data-aos="fade">
          <h2 className="fw-semibold text-center">Target Region</h2>

          <h3 className="country-heading">Countries</h3>

          <div className="grid countries-list">
            {marketArea?.countries?.map((item, index) => (
              <Link
                key={index}
                className="fw-medium g-col-6 g-col-sm-4 g-col-md-3 g-col-lg-2 country-item"
                href={`/${item.slug}`}
              >
                {item?.name}
              </Link>
            ))}
          </div>
          {marketArea?.states &&
            Object.entries(marketArea.states).map(
              ([country, states], index) => (
                <div key={index}>
                  <h4 className="country-heading">States of {country}</h4>
                  <div className="grid countries-list">
                    {states.map((state, idx) => (
                      <Link
                        key={idx}
                        className="fw-medium g-col-6 g-col-sm-4 g-col-md-3 g-col-lg-2 country-item"
                        href={`/${state.slug}`}
                      >
                        {state?.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )
            )}

          {marketArea?.cities &&
            Object.entries(marketArea.cities).map(([state, cities], index) => (
              <div key={index}>
                <h4 className="country-heading">Cities of {state}</h4>
                <div className="grid countries-list">
                  {cities.map((city, idx) => (
                    <Link
                      key={idx}
                      className="fw-medium g-col-6 g-col-sm-4 g-col-md-3 g-col-lg-2 country-item"
                      href={`/${city.slug}`}
                    >
                      {city?.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
        </Container>
      </section>
    </>
  );
}
